module.exports = __webpack_public_path__ + "img/locationAndTax.a511e092.svg";